module.exports = __webpack_public_path__ + "img/contractimg.6e0bca9d.png";